import { exportPDF } from 'features/claims/claimsApi'
import { numberWithCommas } from 'utils'
import { getFileName } from 'utils/helper'

export const EOBDownload = (data: any) => {
  exportPDF(data).then((res: any) => {
    const blob = new Blob([res.data], { type: 'application/pdf' })
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = getFileName(res.headers)
    link.click()
  })
}

export const currencyFormatter = (params: any) => {
  const valueAsNumber = parseFloat(params.value as string)
  return params.value != null ? `$${numberWithCommas(valueAsNumber.toFixed(2))}` : '---'
}

export const formatDos = (params: any) => {
  return (
    <>
      {params.data.dateOfServiceStart} <br /> {params.data.dateOfServiceEnd}
    </>
  )
}
